/**
 * 海关编码-设置页 | 详情页
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2021, all rights reserved. Essa.cn
 */
import React, {PureComponent} from 'react';
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import {Spin, message} from 'antd';
import {Prompt} from 'react-router-dom';
import Lang from "@components/Lang/Lang";
import Locale from "@utils/locale";
import {isEmpty,isEmptyObject,trim,getFileSuffix,cloneObj} from '@utils/utils';
import CustomsDeclarationStickerAction from "../../CustomsDeclarationSticker.action";
import PageCommon from  "@components/PageCommon/PageCommon";
import IconChinaOrderGoods from "@components/Icon/IconDirectPo/IconChinaOrderGoods";//直达商品图标
import OneItem from "./OneItem";
import utilExcelStrict from '@utils/utilExcelStrict';
import "./Details.less";

class Details extends PureComponent{
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            isHadEdit: false, //是否编辑过
            eventCode:'40',
            item:{},
            // 数据源
            list: [
            ],
            // 证书选项
            certDict: [
                { label: Lang({id:'YouZhengShu',default:'有证书'}), value: 1 },  //这个实际是有证 , 当 isFurnishCertificate = 1 且 hasCertificate = 1
                { label: Lang({id:'WuZhengShu',default:'无证书'}), value: 0 },
                { label: Lang({id:'WuZhengShuChuHuo',default:'无证书出货'}), value: 2 }, //这个实际是有证 , 当 isFurnishCertificate = 0 且 hasCertificate = 1
                // { label: 'Orange', value: 'Orange', disabled: true },
            ],
            // 表单格式
            formItemLayout:{
                labelCol: { span: Locale.current()=='ru'?5:3 },
                wrapperCol: { span: Locale.current()=='ru'?17:21 },
                labelAlign: 'left',
            },
            isEdit:false,
        }
        this.saveList={};
        this.listener = e => {
            if(this.state.isHadEdit){
                e.preventDefault();
                e.returnValue = Lang({id:'LiKaiDangQianYeHou，SuoBianJiDeShuJuJiangBuKeHuiFu',default:'离开当前页后，所编辑的数据将不可恢复'}) // 浏览器有可能不会提示这个信息，会按照固定信息提示
            }
        }
    }
    /**
     * 查看详情
     * */
    getDetail(sId){
        this.loading(true);
        //字典code:sale_po_sticker_track_even_code 事件编码 (10:侵权确认,20:侵权审核,30:海关编码,40:证书设置,50:证书审核,60:无证书状态)
        const data = {
            trackId:sId,
            eventCode:this.state.eventCode,
        }
        CustomsDeclarationStickerAction.getStickerDetail(data).then(res=>this.handleRes(res.data)).catch(err=>this.handleRes(err))
    }
    handleRes(res){
        const {success,valid,model,models} = res;
        if(success&&valid){
            const list = models || [];
            list.forEach(item=>{
                const stickerTemplateList = item.stickerTemplateList||[];
                if(item.stickerCode&&stickerTemplateList.length>0){
                    const currItem = stickerTemplateList.find(siItem=>siItem.stickerCode==item.stickerCode);
                    if(currItem&&currItem.stickerCode){// d贴纸模板 有效值 -> 在默认显示可选列表中才算有效，一般已选的会优选显示在此列
                        item.stickerItem = {
                            stickerCode:currItem.stickerCode
                        }
                    }else {
                        item.stickerCode = "";
                        item.stickerItem = {
                            stickerCode:""
                        }
                    }
                }else {
                    item.stickerCode = "";
                    item.stickerItem = {
                        stickerCode:""
                    }
                }
                if(item.goodsCertificateList&&item.goodsCertificateList.length>0){
                    for(let i = 0; i<item.goodsCertificateList.length; i++){
                        item.goodsCertificateList[i].id = item.goodsCertificateList[i].saleGoodsCertificateId;
                    }
                }
                if(item.hasCertificate=== 1 && item.isFurnishCertificate === 0){
                    item.hasCertificate = 2;
                }
                if(item.importTariffRate){
                    item.importTariffRateNew = item.importTariffRate * 100
                }
                if(item.isMandatoryFlag==1){
                    item.isMandatoryFlag = true
                }
                if(item.kizAttrList&&item.kizAttrList.length>0){ // 回显 kiz
                    let kizCategoryVO = {}, categoryAttrList=[],attValues={};
                    item.kizAttrList.forEach(kiaArr=>{
                        if(kiaArr.attrCode=='cat_id'){
                            kizCategoryVO["catId"] = Number(kiaArr.attrValue);
                            kizCategoryVO["catValueName"] = kiaArr.catValueName;
                        }else{
                            categoryAttrList.push({
                                attrId: kiaArr.attrId,
                                attrValue: kiaArr.attrValue
                            })
                            attValues[kiaArr.attrId] = kiaArr.attrValue;
                        }
                    })
                    kizCategoryVO["categoryAttrList"] = categoryAttrList;
                    item.kizCategoryVO = kizCategoryVO;
                    item.attValues = attValues;
                }
                if(!isEmpty(item.remark))item.hasRemark = item.remark;
            })
            this.setState({
                item:model||{},
                list:list,
            })
            this.loading(false);
        }else {
            this.loading(false);
            if(res.message)message.warning(res.message)
        }
    }
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    getCerId(str,pathname){
        let iId = str.length>0?str.substr(1,str.length):'';
        iId = iId?Number(iId):'';
        const isEdit = pathname.indexOf('View')>-1 ? false:true; // 查看模块不可编码
        this.setState({
            iId: iId,
            isEdit:isEdit
        })
        return iId;
    }
    /**
     * 设置是否编辑过
     **/
    setHadEdit(flag){
        this.setState({
            isHadEdit : flag
        })
    }
    /**
     * 保存数据
     * @isSubmit  0 保存 1 提交
     * **/
    saveOther(oInx,data){
        this.saveList[oInx]=data;
    }
    handleSaveData = async(isSubmit) =>{
        this.setState({
            isSubmit:isSubmit
        })
        this.goSave(isSubmit,this.saveList)
    }
    goSave(isSubmit,saveList){
        const {list=[]} = this.state;
        let postList = [];
        let hadErr = false;
        for(let i = 0,iLen = list.length; i<iLen; i++){
            const item = saveList[i]||list[i];
            if (!isEmpty(item.customsCode)&&item.customsCode.length!==10){
                message.warning(Lang({id: "QingShuRuHaiGuanBianMa",default: "请输入十位数的海关编码"}));
                hadErr = true;
                break
            }
            if(isSubmit==1){
                if (isEmpty(item.hasCertificate)){
                    message.warning(Lang({id: "QingXuanZeShiFouYouShangPinZhengShu",default: "请选择是否有商品证书"}))
                    hadErr = true;
                    break;
                }
                item.required = (item.hasCertificate==1 || item.hasCertificate==2)?true:false;// 有证书或者 无证书出货 时必填的内容校验用
                if (item.required&&isEmpty(item.customsCode)){
                    message.warning(Lang({id: "QingShuRuHaiGuanBianMa",default: "请输入十位数的海关编码"}))
                    hadErr = true;
                    break;
                }
                if (item.required&&isEmpty(item.stickerCode)) {
                    message.warning(Lang({id: "XuanZeTieZhiMoBan",default: "选择贴纸模板"}))
                    hadErr = true;
                    break;
                }
                if (item.required&&isEmpty(item.nameRu)) {
                    message.warning(Lang({id: "SheZhiTieZhiPinPai",default: "设置贴纸品名"}))
                    hadErr = true;
                    break;
                }
                // 1有证书时 必选 证书，0无证书必填 说明 ，2无证书出货可忽略
                if(item.hasCertificate === 0&&isEmpty(item.remark)){
                    message.warning(Lang({id: "QingTianXieWuZhengShuShuoMing",default: "请填写无证书说明"}))
                    hadErr = true;
                    break;
                }
                if(item.hasCertificate === 1&&(!item.goodsCertificateList || item.goodsCertificateList.length === 0)){
                    message.warning(Lang({id: "NinShangWeiXuanZeZhengShu",default: "您尚未选择证书"}))
                    hadErr = true;
                    break;
                }
            }
            if(item.isMandatoryFlag){
                // console.log(item.isMandatoryFlag,"item.isMandatoryFlag",item.kizAttrList);
                //校验  kizAttrList
                if(!item.kizCategoryVO||!item.kizCategoryVO.catId){
                    message.warning(Lang({id: "QingXuanZeShangPinFenLei",default: "请选择商品分类"}));
                    hadErr = true;
                    break
                }else {
                    const categoryAttrValues = item.kizCategoryVO.categoryAttrList;
                    if(!categoryAttrValues||isEmptyObject(categoryAttrValues)){
                        hadErr = true;
                        break;
                    }else {
                        const curKiz = item.kizAttrList.find(kiz=>kiz.catId==item.kizCategoryVO.catId)||{};
                        const categoryAttrList = curKiz.categoryAttrList||[];
                        for(let i = 0; i < categoryAttrList.length; i++){
                            const att = categoryAttrList[i];
                            const currItem = categoryAttrValues.find(va=>va.attrId == att.attrId);
                            if(!currItem||!currItem.attrValue){
                                hadErr = true;
                                break;
                            }
                        }
                    }
                    if(hadErr){
                        message.warning(Lang({id: "QingTianXieWanZhengDeBiTianXiang",default: "请填写完整的必填项"}));
                        hadErr = true;
                        break;
                    }
                }
            }
            let poItem = {
                hasCertificate: item.hasCertificate===2?1:item.hasCertificate,
                isFurnishCertificate:item.hasCertificate === 2?0:(item.hasCertificate===1?1:-1),
                // certificateCode: item.certificateCode, 此处不用保存
                nameRu: item.nameRu,
                skuName: item.skuName,
                poId: item.poId,
                poItemId: item.poItemId,
                remark: item.remark,
                skuId: item.skuId,
                stickerCode: item.stickerItem.stickerCode,
                trackItemId: item.trackItemId,
                goodsDesc: item.goodsDesc,
                customsCode: item.customsCode,
                goodsCertificateList: item.hasCertificate === 1 ?item.goodsCertificateList:[],
                importTariffRate: item.importTariffRateNew?(item.importTariffRateNew/100):null,
                isMandatoryFlag: item.isMandatoryFlag?1:0,//是否开启GTIN必填项 0:否 1:是
                kizCategoryVO: item.kizCategoryVO,//kiz分类属性设置
                stickerIconCodeList: item.stickerIconCodeList, //贴纸图标编码列表
                isUpdateGtin: item.isUpdateGtin?1:0,
            }
            if (!isEmpty(item.id)) poItem['id'] = item.id;
            if (!isEmpty(item.isTort)) poItem['isTort'] = item.isTort;
            if (!isEmpty(item.salePoStickerTrackId)) poItem['salePoStickerTrackId'] = item.salePoStickerTrackId;
            postList.push(poItem)
        }
        if(hadErr){
            return false;
        }
        this.loading(true);
        const {iId,eventCode } = this.state;
        const postData = {
            trackId: iId,
            eventCode:eventCode,
            saveStatus:isSubmit,
            trackItemList:postList
        }
        CustomsDeclarationStickerAction.saveSticker(postData).then(res=>this.handleSaveRes(res.data,isSubmit)).catch(err=>this.handleSaveRes(err))
    }
    handleSaveRes(res,isSubmit){
        this.loading(false);
        const {success,valid,model,models} = res;
        if(success&&valid){
            this.setHadEdit(false); // 保存成功后 设置可直接离开
            if(isSubmit==1){
                message.success(Lang({id: "CaoZuoChengGong",default: "操作成功"}));
                this.setState({
                    isEdit:false
                })
               this.timer = setTimeout(()=>{
                    this.props.history.push('/customsDeclarationSticker/stickerBrand')
                },1000);
            }
            if(isSubmit==0) {
                message.success(Lang({id: "YiBaoCun",default: "已保存"}));
            }
        }else if(res.message){
            message.warning(res.message);
        } else message.warning(Lang({id:'CaoZuoShiBai',default: "操作失败",}));
    }

    /**
     * 下载按钮
     * */
    handleDownExcel(list,sPoCode) {
        let needDownList = [];
        list.forEach((yItem={},inx)=>{
            const item = this.saveList[inx]||yItem;
            if(isEmpty(item.hasCertificate)||item.hasCertificate !==0){//未设置或非无证书
                needDownList.push(item)
            }
        })
        if(needDownList.length>0){
            this.loading(true);
            const columns = [
                {
                    header: Lang({id: 'ShangPin', default: '商品'}),
                    key: 'skuPictureUrlno',
                    width: 30,
                },
                {
                    header: Lang({id: 'ShangPinMingChen', default: '商品名称'}),
                    key: 'title',
                    width: 30,
                },
                {
                    header: Lang({id: 'ShangPinBianMa', default: '商品编码'}),
                    key: 'skuNo',
                    width: 15,
                },
                {
                    header: Lang({id: 'BaoZhuangNianLingBiaoQian', default: '包装年龄标签'}),
                    key: 'mark',
                    width: 20,
                },
                {
                    header: Lang({id: 'CaiZhi', default: '材质'}),
                    key: 'mainMaterials',
                    width: 20,
                },
                {
                    header: Lang({id: 'LeiMu', default: '类目'}),
                    key: 'categoryName',
                    width: 20,
                },
                {
                    header: Lang({id: 'BaoZhuangLeiXing', default: '包装类型'}),
                    key: 'packagingType',
                    width: 15,
                },
                {
                    header: Lang({id: 'YouZhengShu', default: '有证书'}),
                    key: 'hasCertificate',
                    width: 15,
                },
                {
                    header: Lang({id: 'certificateEncoding', default: '证书编码'}),
                    key: 'certificateCode',
                    width: 15,
                },
                {
                    header: Lang({id: 'XuanZeTieZhiMoBan', default: '选择贴纸模板'}),
                    key: 'stickerCode',
                    width: 15,
                },
                {
                    header: Lang({id: 'TieZhiMoBanMingCheng', default: '贴纸模板名称'}),
                    key: 'stickerName',
                    width: 15,
                },
                {
                    header: Lang({id: 'TieZhiPinMing', default: '贴纸品名'}),
                    key: 'nameRu',
                    width: 15,
                }
            ]
            const downList = this.handleDownList(needDownList);
            const fileName = Lang({id: "SheZhiTieZhiPinPai",default: "设置贴纸品名"})+'_'+sPoCode
            utilExcelStrict.exportFile(columns, downList, fileName, res => {
                this.timer =  setTimeout(() => this.loading(false), 400)
            })
        }else message.warning(Lang({id: 'DangQianWuKeXiaZaiShangPin', default: '暂不支持无证书商品下载'}));
    }
    /**
     * 处理下载数据 TODO 优化合并在渲染页面时
     * */
    handleDownList(list = []){
        let downList = [];
        list.forEach(item=>{
            const attributeList = item.attributeList||[];
            let certificateCode = [];
            if(item.goodsCertificateList && item.hasCertificate === 1){
                certificateCode = item.goodsCertificateList.map(item => item.code)
            }

            let packagingType = ''; // 包装类型
            let sMark = ''; // 包装年龄标签
            attributeList.forEach(att=>{
                if(att.attributeCode == 'PKG'){
                    let str = ""
                    if(att.optionList&&att.optionList.length>0)att.optionList.map(item=>str += item.optionName+"");
                    packagingType = str;
                }
                if(att.attributeCode == 'bznlb'){
                    let str = ""
                    if(att.optionList&&att.optionList.length>0)att.optionList.map(item=>str += item.optionName+"");
                    sMark = str
                }
            })
            let downItem = {...item}
            let sStickerName = '';
            //  有证书 1 , '无证书' : 0, 2 证书出货
            if(item.hasCertificate===1){
                downItem['hasCertificate'] = Lang({id:'YouZhengShu',default:'有证书'})
            }

            if(item.hasCertificate===2){
                downItem['hasCertificate'] = Lang({id:'WuZhengShuChuHuo',default:'无证书出货'})
            }

            if(!isEmpty(item.stickerCode)&&item.stickerItem&&item.stickerItem.stickerName){
                sStickerName = item.stickerItem.stickerName;
            }else if(!isEmpty(item.stickerCode)&&item.stickerTemplateList&&item.stickerTemplateList.length>0){
                const stickerTemplateList = item.stickerTemplateList;
                const currItem = stickerTemplateList.find(siItem=>siItem.stickerCode==item.stickerCode);
                if(currItem&&currItem.stickerCode){
                    sStickerName = currItem.stickerName;
                }
            }
            downItem['thumbnail'] = item.skuPictureUrl;
            downItem['title'] = item.showEnTitle==1? item.skuNameEn: item.skuNameRu;
            downItem['packagingType'] = packagingType;
            downItem['mark'] = sMark;
            downItem['stickerName'] = sStickerName;
            downItem['certificateCode'] = certificateCode.join(',');

            downList.push(downItem)
        })
        return downList;
    }
    onRefPageCommon = (ref) => this.onRefPageCommonChild = ref;
    componentDidMount() {
        window.addEventListener('beforeunload', this.listener);
        const iconCodeList = __getDictList("po_item_sticker_icon_code")||[];// po明细贴纸图标文件
        this.setState({
            iconCodeList:iconCodeList
        })
        const { location:{search,pathname} } = this.props;
        const sId = this.getCerId(search,pathname);
        this.getDetail(sId);
    }
    componentWillUnmount(){
        this.setState = (state, callback) => {
            return;
        }
        window.removeEventListener('beforeunload', this.listener);
        if(this.timer)clearTimeout(this.timer)
    }
    render(){
        const { loading,isEdit,list,isHadEdit,uploadSetting,item, isSubmit="",iconCodeList=[]} = this.state;
        const currPageName = Lang({id: "SheZhiTieZhiPinPai",default: "设置贴纸品名"});
        let btnList;
        if(isEdit){
            btnList = [
                {   btn: Lang({id:"XiaZai",default:"下载"}),
                    icon:"ri-download-cloud-line mr_4 color-blue",
                    btnClick:()=>this.handleDownExcel(list,item.poCode)
                },{
                    btn: Lang({id:"BaoCun",default:"保存"}),
                    icon:"ri-save-3-line color-green mr_4",
                    btnClick:()=>this.handleSaveData(0),
                    auth:"Sticker_Task_Save"
                },{ 
                    btn: Lang({id:"TiJiao",default:"提交"}),
                    icon:"ri-git-repository-commits-fill color-green mr_4",
                    btnClick:()=>this.handleSaveData(1),
                    auth:"Sticker_Task_Submit"
                }
            ]
        }
        return (
        <PageCommon onRef={this.onRefPageCommon} className={"transferWrap"} btnList={btnList}>
            <Spin tip='loading' spinning={loading}>
                <Prompt
                    when={isHadEdit}
                    message={() =>Lang({id:'LiKaiDangQianYeHou，SuoBianJiDeShuJuJiangBuKeHuiFu',default:'离开当前页后，所编辑的数据将不可恢复'})}
                />
                {
                item.poCode?<CommonBreadcrumb list={[
                    { name:currPageName,link:'/customsDeclarationSticker/stickerBrand'},{name:item&&item.poCode?item.poCode:''}]}></CommonBreadcrumb>:null
                }
                <div className="stickerBrandStyle">
                    <div className={'content'}>
                        <div className={'title mb_8'}>{currPageName}</div>
                        {item.isChinaOrder==1?<div className={"flex-item-ver-center mb_8 color-red2"}>
                            <IconChinaOrderGoods size={20} />
                            <span className={"ml_4 color-red2"}>
                                {Lang({id:'DangQianDingDanKeHuYaoQiuZhongGuoZhiFaTiShi', default:'当前订单客户要求中国直发，请注意贴纸模板设置'})}
                            </span>
                        </div>:null}
                        <div className={'itemList'}>
                            {list.map((field,inx) =><OneItem item={field} isEdit={isEdit} key={"oneItem_"+inx}
                                                             model={item}
                                                             isHadEdit={isHadEdit}
                                                             iconCodeList={iconCodeList}
                                                             isSubmit={isSubmit}
                                                             inx={inx}
                                                             saveOther={(data)=>this.saveOther(inx,data)}
                                                             setHadEdit={(flag)=>this.setHadEdit(flag)}
                            />)}
                        </div>
                    </div>

                </div>
            </Spin>
        </PageCommon>
        )
    }
}
export default Details;
